import React from 'react'
import classNames from 'classnames'
import s from './NPSSurvey.less'
import SVGIcon from '../svg/SVGIcon'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { closeNPSSurvey } from '../../store/ui/ui.actions'
import T from '../i18n/T'
import { npsLinks } from '../../parameters'
import { isGE } from '../Device'
import { selectIsItineraryUniverse } from '../../store/history/history.selectors'
import { useSelector } from 'react-redux'
import { useAction, withEverySelectorTruthy } from '../utils/react-redux'
import { selectShouldShowNPSSurvey } from '../../store/ui/ui.npssurvey.selectors'
import RectangleActionButton, { COLOR_GREY_EMPTY } from '../genericComponents/buttons/RectangleActionButton'

export const NPS_SURVEY_CONTEXT_ITINERARY = 'itinerary_results'
export const NPS_SURVEY_CONTEXT_POI = 'poi_card'

const useNPSLinks = () => {
  const isItinerary = useSelector(selectIsItineraryUniverse)
  if (isItinerary) return isGE() ? npsLinks.itinerary_results_desktop : npsLinks.itinerary_results_mobile
  return isGE() ? npsLinks.poi_card_desktop : npsLinks.poi_card_mobile
}

const ParticipateButton = ({ closeSurvey }) => {
  const href = useNPSLinks()

  return (
    <RectangleActionButton
      className={s.participateButton}
      color={COLOR_GREY_EMPTY}
      label="survey.ok_button"
      href={href}
      targetBlank
      nofollow
      onClick={closeSurvey}
    />
  )
}

const CloseButton = ({ closeSurvey }) => (
  <span className={classNames('icon', s.closeButton)} onClick={closeSurvey}>
    <SVGIcon icon="croix-android" />
  </span>
)

const NPSSurvey = () => {
  const execClose = useAction(closeNPSSurvey)

  return (
    <div className={s.NPSSurvey}>
      <div className={s.content}>
        <p className={s.title}>
          <T id="survey.title" />
        </p>
        <p className={s.description}>
          <T id="survey.description" />
          <ParticipateButton closeSurvey={execClose} />
        </p>
        <CloseButton closeSurvey={execClose} />
      </div>
    </div>
  )
}

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(withEverySelectorTruthy(selectShouldShowNPSSurvey)(NPSSurvey))
